import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight, Lock, Download, Smartphone } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section id="final-cta-section" className="w-full py-24 px-6 bg-charcoal text-white relative overflow-hidden" data-id="element-52">
      {/* Background decoration */}
      <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-terracotta/20 blur-[120px] pointer-events-none" data-id="element-53"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-54">
        <FadeIn data-id="element-55">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 font-serif leading-tight" data-id="element-56">
            Hay dos caminos frente a ti ahora mismo:
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-57">
          <FadeIn delay={0.2} direction="left" data-id="element-58">
            <div className="bg-charcoal-light/30 border border-gray-700 p-8 rounded-3xl h-full opacity-70" data-id="element-59">
              <h3 className="text-xl font-bold text-gray-300 mb-4 border-b border-gray-700 pb-4" data-id="element-60">
                Camino 1
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-61">
                Cierras esta página. Esta noche vuelves a pedir que apaguen la
                pantalla. Vuelven los gritos. Vuelve la culpa. Mañana es igual.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="right" data-id="element-62">
            <div className="bg-terracotta/10 border-2 border-terracotta p-8 rounded-3xl h-full relative" data-id="element-63">
              <div className="absolute -top-4 -right-4 bg-terracotta text-white w-8 h-8 rounded-full flex items-center justify-center font-bold" data-id="element-64">
                ✓
              </div>
              <h3 className="text-xl font-bold text-white mb-4 border-b border-terracotta/30 pb-4" data-id="element-65">
                Camino 2
              </h3>
              <p className="text-cream leading-relaxed" data-id="element-66">
                Inviertes menos de lo que cuesta un café. Y esta noche, por
                primera vez en mucho tiempo, la transición termina en abrazo y
                no en portazo.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-67">
          <div className="text-center" data-id="element-68">
            {/* Animated arrow pointing to button */}
            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="text-amber text-4xl mb-4" data-id="element-69">
              👇
            </motion.div>
            <p className="text-amber font-bold text-lg uppercase tracking-wider mb-6 animate-pulse" data-id="element-70">
              ¡Haz clic aquí para acceder ahora!
            </p>

            <div className="relative inline-block w-full md:w-auto" data-id="element-71">
              {/* Pulsing glow ring behind button */}
              <motion.div animate={{
              scale: [1, 1.05, 1],
              opacity: [0.4, 0.8, 0.4]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -inset-2 bg-sage/30 rounded-3xl blur-md" data-id="element-72"></motion.div>

              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.97
            }} animate={{
              boxShadow: ['0 0 20px rgba(107,158,107,0.4)', '0 0 60px rgba(107,158,107,0.7)', '0 0 20px rgba(107,158,107,0.4)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="relative w-full md:w-auto bg-sage-dark hover:bg-sage text-white text-xl md:text-2xl font-bold py-7 px-12 rounded-2xl transition-all flex flex-col md:flex-row items-center justify-center gap-3 mx-auto mb-4 border-2 border-sage-light/50" data-id="element-73">
                <span className="flex items-center gap-3" data-id="element-74">
                  🛒 SÍ, QUIERO PAZ EN MI HOGAR
                </span>
                <span className="bg-white text-sage-dark px-5 py-2 rounded-xl text-xl font-extrabold shadow-inner" data-id="element-75">
                  ACCEDER POR $11.99 USD
                </span>
                <ArrowRight className="w-7 h-7 hidden md:block" data-id="element-76" />
              </motion.button>
            </div>

            <motion.p animate={{
            opacity: [0.5, 1, 0.5]
          }} transition={{
            duration: 3,
            repeat: Infinity
          }} className="text-amber-light text-sm font-medium mt-4 mb-8" data-id="element-77">
              🔒 Pago seguro • Acceso inmediato • Sin riesgos
            </motion.p>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-16" data-id="element-78">
              <span className="flex items-center gap-2" data-id="element-79">
                <Download className="w-4 h-4" data-id="element-80" /> Acceso inmediato (PDF)
              </span>
              <span className="flex items-center gap-2" data-id="element-81">
                <Smartphone className="w-4 h-4" data-id="element-82" /> Compatible con todo
                dispositivo
              </span>
              <span className="flex items-center gap-2" data-id="element-83">
                <Lock className="w-4 h-4" data-id="element-84" /> Pago 100% seguro
              </span>
            </div>

            <div className="max-w-2xl mx-auto bg-charcoal-light/50 p-8 rounded-2xl border border-gray-700" data-id="element-85">
              <p className="text-terracotta-light font-bold uppercase tracking-wider text-sm mb-4" data-id="element-86">
                Una última cosa...
              </p>
              <p className="text-xl md:text-2xl font-serif italic text-cream mb-4" data-id="element-87">
                "Tu hijo no necesita un padre perfecto. Necesita un padre que
                tenga las herramientas correctas."
              </p>
              <p className="text-lg text-gray-300" data-id="element-88">
                Hoy puedes ser ese padre. Por $11.99.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}